package com.partejar.app.feature.calendar

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
actual fun rememberCalendarIntegration(): CalendarIntegration = remember { UnsupportedCalendarIntegration }

private data object UnsupportedCalendarIntegration : CalendarIntegration {
    override suspend fun getPermissionStatus() = CalendarPermissionStatus.UNAVAILABLE
    override suspend fun requestPermission() = CalendarPermissionStatus.UNAVAILABLE
    override suspend fun openEventEditor(event: CalendarEventDraft) = CalendarEventOpenResult.UNAVAILABLE
    override fun openSystemSettings() = Unit
}
